import studentExchangeService from '@/shared/services/domain/studentExchange'
import axios, { AxiosStatic } from 'axios'
import studyService from '@/shared/services/domain/studies'

const services = ($axios: AxiosStatic) => ({
    studentExchange: studentExchangeService($axios),
    studentStudy: studyService($axios)
})

export default services(axios)
